/**
 * @generated SignedSource<<336b453a32729ca4caa3f94b7d25c86f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RedeemRewardsInput = {
  clientMutationId?: string | null;
  points: number;
  programId: string;
  rewardCardSku: string;
};
export type RewardCard_Mutation$variables = {
  input: RedeemRewardsInput;
};
export type RewardCard_Mutation$data = {
  readonly redeemRewards: {
    readonly panelist: {
      readonly convertedRewardsBalance: number | null;
      readonly redeemedRewardsPoints: number | null;
      readonly rewardsBalance: number | null;
    } | null;
  } | null;
};
export type RewardCard_Mutation = {
  response: RewardCard_Mutation$data;
  variables: RewardCard_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rewardsBalance",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "convertedRewardsBalance",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "redeemedRewardsPoints",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RewardCard_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RedeemRewardsPayload",
        "kind": "LinkedField",
        "name": "redeemRewards",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PanelistNode",
            "kind": "LinkedField",
            "name": "panelist",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RewardCard_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RedeemRewardsPayload",
        "kind": "LinkedField",
        "name": "redeemRewards",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PanelistNode",
            "kind": "LinkedField",
            "name": "panelist",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "58495daf49207917c3f85970b1cac215",
    "id": null,
    "metadata": {},
    "name": "RewardCard_Mutation",
    "operationKind": "mutation",
    "text": "mutation RewardCard_Mutation(\n  $input: RedeemRewardsInput!\n) {\n  redeemRewards(input: $input) {\n    panelist {\n      rewardsBalance\n      convertedRewardsBalance\n      redeemedRewardsPoints\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f210916fd39802fc4b2eac59b77c469b";

export default node;
